export const crmEstagioExpress = {
    LeadColetado: "1057464709",
    CadastroCNPJ: "1076026123",
    NegocioFechado: "1057466693",
    NegocioPerdido: "1057466694",
}